var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoachActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39122_21972",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39122_21972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00634 17.0222H13.0174V15.019H6.00634V17.0222ZM16.0222 17.0222H18.0254V7.00634H16.0222V17.0222ZM6.00634 13.0158H13.0174V11.0127H6.00634V13.0158ZM6.00634 9.00951H13.0174V7.00634H6.00634V9.00951ZM4.00317 21.0285C3.4523 21.0285 2.98072 20.8324 2.58843 20.4401C2.19614 20.0478 2 19.5762 2 19.0254V5.00317C2 4.4523 2.19614 3.98072 2.58843 3.58843C2.98072 3.19614 3.4523 3 4.00317 3H20.0285C20.5794 3 21.051 3.19614 21.4433 3.58843C21.8355 3.98072 22.0317 4.4523 22.0317 5.00317V19.0254C22.0317 19.5762 21.8355 20.0478 21.4433 20.4401C21.051 20.8324 20.5794 21.0285 20.0285 21.0285H4.00317ZM4.00317 19.0254H20.0285V5.00317H4.00317V19.0254Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachActivities);
export default __webpack_public_path__ + "static/media/coach-activities.85be9343beff9b2a76c8d77ba3e9f2fb.svg";
export { ForwardRef as ReactComponent };